import api from '..';

export type Payload = {
  venda_id: number;
  cliente_cpf: string;
};

export const requestActivateSale = async (payload: Payload) => {
  const { data } = await api.post(`/core/vendas/non-auth/ativar/`, payload);

  return data;
};
